/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

.denominator {
  opacity: 0.75;
}
